export const formatCardNumber = (value) => {
    // Sadece sayıları al ve 16 karakterle sınırla
    const onlyNums = value.replace(/[^\d]/g, '').slice(0, 16);
  
    // Sayıları gruplara ayır
    const parts = [];
    for (let i = 0; i < onlyNums.length; i += 4) {
      parts.push(onlyNums.substring(i, i + 4));
    }
  
    // Grupları birleştir ve araya "-" ekle
    return parts.join('-');
  };
  export function formatZuluTime(zuluTime) {
    // Zulu zamanını Date nesnesine dönüştürme
    const date = new Date(zuluTime);
  
    // Kullanıcının yerel diline ve zaman dilimine göre tarihi formatlama
    const options = {
      year: 'numeric', month: 'long', day: 'numeric',
      hour: 'numeric', minute: '2-digit', second: '2-digit',
      hour12: false // 24 saat formatını kullan
    };
  
    // Formatlanmış tarihi döndür
    return new Intl.DateTimeFormat('tr-TR', options).format(date);
  }
  